











































































import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import LoginBase from "./LoginBase";
//import facebookLogin from 'facebook-login-vuejs';
@Component
export default class Login extends LoginBase {


	styleBackground() {
		return this.isTestEnvironment ? "background-color:darkcyan;" : "";
	}

	// zobrazeni login stranky funguje jako odhlaseni
	created() {
		this.isLoginPage = true;
		super.setMainDescriptionOld(this.$t('login.login').toString(), this.$t('login.login').toString(), this.$t('login.login').toString(), this.$t('login.login').toString());
		super.setAlertModalId('alertModalIdLogin');
		this.clearUserCredentials();
		this.createdBase();
		this.versionNumberInLoginPage = "1.4.06";
		this.getVersionNumberFromREST();
	};

	forgetPassword() {
		this.forgetPasswordBase();
	}

	registeredToSystem() {
		this.registeredToSystemBase();
	}

	getVersionNumber() {
		//return this.$t('global.version').toString() + " " + this.versionNumber;
		return "verze " + this.versionNumber;
	}

	enterPress(): void {
		this.login();
	}

	mounted() {
		this.showParamsErrorMessage();
		this.recongnizeLang();
		this.getAllowOauthBase();


		if (this.$route.query.code != undefined) {
			this.activeUserByUrl(this.$route.query.code.toString());
		}
	}

	loginData: any = null;
	login() {
		this.userService.login(this.formData).then((response) => {
			if (response.data.idGeneralTerm > 0) {
				this.showAlertModalById("allowGlobalTerm");
				this.loginData = response.data;
			}
			else {
				this.saveUserCredentials(response.data);
			}
		}).catch((error) => {
			var errorMessages = error.data.errors[0];
			this.showAlertModalWithTitleAndContent(this.$t('login.loginNotSuccess').toString(), errorMessages);
		});
	}

	goAllowGeneralTerm() {
		this.allowGeneralTermBase(this.loginData);
	}

	googleLogin() {
		this.googleLoginBase();
	}

}
